<article class="w-full">
    <a [href]="dataSource.Url" target="_blank" class="card-body block h-[16.5rem] shadow-sm hover:shadow-md transition-all rounded-2xl">
        <div class="h-full w-full block overflow-hidden rounded-2xl border border-t-gray-200">
            <img [ngSrc]="dataSource.PictureUrl"
            [loading]="'eager'"
             height="70" width="352" class="card-image" [alt]="dataSource?.Name" >
        </div>
    </a>

    <h4 (click)="goToCity(dataSource.Url)" class="text-base font-bold mt-2 me-2 cursor-pointer">{{ dataSource.Name }}</h4>
    <p class="text-xs text-black-300 mt-2">{{ dataSource.Count }} واحد اقامتی</p>
</article>